import {
  Layers,
  Code2,
  GitBranch,
  Database,
  Navigation,
  Zap,
  TestTube2,
  Gauge,
  Building2,
  Workflow,
  Globe,
  Package,
  BrainCircuit,
  Monitor,
  GitMerge,
  HelpCircle,
} from 'lucide-react';
import type { LucideProps } from 'lucide-react';

const ICON_MAP: Record<string, React.ComponentType<LucideProps>> = {
  Layers,
  Code2,
  GitBranch,
  Database,
  Navigation,
  Zap,
  TestTube2,
  Gauge,
  Building2,
  Workflow,
  Globe,
  Package,
  BrainCircuit,
  Monitor,
  GitMerge,
};

interface Props extends LucideProps {
  name: string;
}

export function CategoryIcon({ name, ...props }: Props) {
  const Icon = ICON_MAP[name] ?? HelpCircle;
  return <Icon {...props} />;
}
